(function () {
    'use strict';

    angular.module('swif.framework')
    .factory('swifMomentUtility', swifMomentUtility);

    /**
    * @ngdoc service
    * @name swif.framework.swifMomentUtility
    * @requires swif.framework.userService
    * @requires swif.framework.msgService
    * @requires swif.framework.settingsService
    * @requires swif.framework.dataService
    * @description a utility to manipulate date / datestring with UTC and timezone
    **/
    function swifMomentUtility(userService, msgService, settingsService, dataService) {
        'ngInject';
        var settings = settingsService;
        var data = dataService;
        var service = {};
        service.DATE_KEYWORDS = settings.DATE_KEYWORDS;
        service.getMomentFromKeywords = function (keyword) {
            var date;
            switch (keyword) {
            case 'FIRSTDAYWEEK':
                date = moment().weekday(0);
                break;
            case 'LASTDAYWEEK':
                date = moment().weekday(6);
                break;
            case 'FIRSTDAYMONTH':
                date = moment().startOf('month');
                break;
            case 'LASTDAYMONTH':
                date = moment().endOf('month');
                break;
            case 'OVERMONTH':
                date = moment().add(1, 'months');
                break;
            case 'OUTDATED':
                date = moment();
                break;
            }
            return date;
        };
        service.getDateFromKeywords = function (keyword) {
            var m = service.getMomentFromKeywords(keyword);
            return m.toDate();
        };
         /**
         * formatHours(0.5) -> '30 minutes'
         */
        var tz;
        service.getTimeZone = function () {
            if (!tz) {
                tz = userService.getTimeZone();
            }
            if (!tz) {
                msgService.addError({
                    type: 'JavaScript',
                    status: 'You user doesn t have timezone configured'
                });
            }
            return tz;
        };
        var formatDate = 'YYYY-MM-DD';
        var formatDatetime = 'YYYY-MM-DD HH:mm:00';
        var format = function (d, inputFormat, outputFormat) {
            outputFormat = outputFormat || inputFormat;
            var mtz, utc;
            if (d) {
                if (typeof d === 'string') {
                    //from the server so it's UTC
                    utc = moment.utc(d, inputFormat);
                } else if (moment.isMoment(d)) {
                    if (!d._isUTC) {
                        utc = d.utc();
                    } else {
                        utc = d;
                    }
                } else {
                    if (_.isDate(d)) {
                        utc = moment(d).utc();
                    }
                }
                if (utc) {
                    mtz = utc.tz(service.getTimeZone());
                    if (mtz) {
                        return mtz.format(outputFormat);
                    }
                }
            }
        };
        service.swifHumanizer = humanizeDuration.humanizer({
            language: 'fr',
            halfUnit: false,
            delimiter: ' ',
            spacer: '',
            round: true,
            languages: {
                fr: {
                    y: 'an',
                    w: 's',
                    d: 'j',
                    h: 'h',
                    m: 'm',
                    s: 's',
                    ms: 'ms',
                    decimal: ','
                }
            }
        });
        service.formatHours = function (hours, isRaw) {
            var language;
            if (!isRaw) {
                language = 'fr';
            }
            if (hours) {
                var duration = moment.duration({hours: hours});
                if (language) {
                    return service.swifHumanizer(
                        duration.asMilliseconds(),
                        {language: language, units: ['h','m']}
                    );
                } else {
                    //https://github.com/moment/moment/issues/1048
                    return Math.floor(duration.asHours()) + moment.utc(duration.asMilliseconds())
                    .format(':mm:ss');
                }
            } else if (hours === 0) {
                return '0';
            }
        };
        /**
         * convert a date string in UTC to a string
         * in the timezone of the user
         */
        service.formatDate = function (date, outputFormat) {
            if (_.contains(service.DATE_KEYWORDS, date)) {
                date = service.getDateFromKeywords(date);
            }
            if (date) {
                if (typeof date === 'string') {
                    //from the server so it's UTC
                    date = moment(date, formatDate);
                } else if (_.isDate(date)) {
                    date = moment(date);
                }
                return date.format(outputFormat || 'LL');
            }
        };
        service.formatDatetime = function (datetime, outputFormat) {
            if (datetime) {
                return format(datetime, formatDatetime, outputFormat || 'LLL');
            }
        };
        service.fixPlanningTZ = function (datetime) {
            //var format = 'YYYY-MM-DD HH:mm:00';
            //var formated = datetime.format(format);
            return moment.tz(datetime.format(), service.getTimeZone()).utc();
        };
        service.getMomentDate = function (date) {
            var m;
            //the date must be in the user time zone
            if (typeof date === 'string') {
                m = moment.tz(date, formatDate, service.getTimeZone());
            } else if (moment.isMoment(date)) {
                m = moment.tz(date.format(), formatDate, service.getTimeZone());
            } else if (_.isDate(date)) {
                m = moment(date.toISOString()).tz(service.getTimeZone());
            }
            if (m) {
                return  m.utc();
            }
        };
        service.getMomentNow = function () {
            return moment.tz(service.getTimeZone());
        };
        service.getMomentDatetime = function (date) {
            var m;
            //the date must be in the user time zone
            if (typeof date === 'string') {
                m = moment.tz(date, formatDatetime, service.getTimeZone());
            } else if (moment.isMoment(date)) {
                if (date._isUTC) {
                    m = moment.tz(date, service.getTimeZone());
                } else {
                    m = date;
                }
            } else if (_.isDate(date)) {
                m = moment(date.toISOString()).tz(service.getTimeZone());
            }
            if (m) {
                return  m.utc();
            }
        };
        service.parseDate = function(date) {
            var m = service.getMomentDate(date);
            if (m) {
                return  m.format(formatDate);
            }
        };
        service.parseDatetime = function(date) {
            var m = service.getMomentDatetime(date);
            if (m) {
                return  m.format(formatDatetime);
            }
        };
        service.addHours = function (start, hours) {
            return moment.utc(start)
                .add(moment.duration({hours: hours})).format(formatDatetime);
        };

        // @param tzCOntext: (string) Optionnal, if set, will compute the diff with TZ dates, instead of UTC
        //      - available values are: 'user' to set the TZ to the user one, otherwise, any valid TZ can be set
        //      - by default, UTC is set if noting is supplied
        service.getHours = function (start, end, tzContext) {
            if(tzContext === 'user') {
                tzContext = service.getTimeZone();
            } else {
                tzContext = tzContext || 'UTC';
            }
            if (typeof start === 'string') {
                return moment.duration(moment.utc(end).tz(tzContext).diff(moment.utc(start).tz(tzContext))).asHours();
            } else {
                // I force start and end to be a moment object,
                // as moment() constructor works both on a moment Object and a native JS Date object
                return moment.duration(moment(end).diff(moment(start))).asHours();
            }
        };
        service.timeago = function (time) {
            var utc, mtz;
            if (typeof time === 'string') {
                //from the server so it's UTC
                utc = moment.utc(time, formatDatetime);
            } else if (moment.isMoment(time)) {
                if (!time._isUTC) {
                    utc = time.utc();
                } else {
                    utc = time;
                }
            } else {
                if (_.isDate(time)) {
                    utc = moment(time).utc();
                }
            }
            if (utc) {
                mtz = utc.tz(service.getTimeZone());
                if (mtz) {
                    return mtz.fromNow();
                }
            }
        };
        service.specialdays = {};
        service.specialdays_events = [];
        service.initialized = false;
        service.add_specialday = function (spd) {
            service.specialdays_events.push(spd);
            var _addDay = function (day) {
                if (service.specialdays[day]) {
                    service.specialdays[day] += ', ' + spd.name;
                } else {
                    service.specialdays[day] = spd.name;
                }
            };
            if (spd.date_end && spd.date_end !== spd.date_start) {
                //iterate over all dates to create one key per date
                var mstart = moment(spd.date_start);
                var mend = moment(spd.date_end).add(1, 'days'); //include date_end
                for (var m = mstart; m.isBefore(mend); m.add(1, 'days')) {
                    _addDay(m.format('YYYY-MM-DD'), spd.name);
                }
            } else {
                _addDay(spd.date_start, spd.name);
            }
        };
        service.load_special_days = function () {
            //reset data if exists but keeping the references
            data.replaceObj(service.specialdays, {});
            data.replaceObj(service.specialdays_events, []);
            data.searchRead('specialday', {limit:0}).then(function (data) {
                _.forEach(data.records, function (spd) {
                    service.add_specialday(spd);
                });
                service.initialized = true;
            });
        };
        service.get_specialday = function (dt) {
            var m = service.getMomentDatetime(dt);
            if (m) {
                var d = service.formatDatetime(m, formatDate);
                return service.specialdays[d];
            }
        };
        return service;
    }

    

})();
